import {
  formatTime,
  formatDate,
  formatDateTime,
  formatDateTimeNow
} from "@/utils/date";
import { arDZ, enUS, fr } from "date-fns/locale";

const locales = { fr, ar: arDZ, en: enUS };

export default {
  methods: {
    formatTime,
    formatDate,
    formatDateTime,
    formatDateTimeNow(str) {
      return formatDateTimeNow(str, locales[this.$i18n.locale]);
    }
  }
};
